/** Creator profile (t('creator.…')) */
export default {
	breadcrumb: "Creator Profile",
	pageTitle: "Creator Profile - SeerQ",
	likes: "Likes",
	followers: "Followers",
	privateChat: "Message",
	introEmpty: "No bio yet",
	tabVideo: "Videos",
	tabArticle: "Articles",
	videoEmpty: "No videos yet",
	articleEmpty: "No articles yet",
	loadMore: "Load more",
};
